import { ExportCsv, ExportPdf } from "@material-table/exporters";
import { storage } from "configs/firebaseConfigs";

import {
  uploadBytes,
  getDownloadURL,
  deleteObject,
  ref as storageRef,
} from "firebase/storage";

export const uploadFile = async ({ path, file }) => {
  try {
    const fileRef = storageRef(storage, path);

    await uploadBytes(fileRef, file);

    const downloadUrl = await getDownloadURL(fileRef);
    return downloadUrl;
  } catch (error) {
    console.log(error);
  }
};

export const deleteFile = async (path) => {
  try {
    const fileRef = storageRef(storage, path);
    await deleteObject(fileRef);
  } catch (error) {
    console.log(error);
  }
};

export const muiTable = {
  styles: {
    boxShadow: "none",
    borderRadius: "8px",
    padding: "8px",
    margin: "8px",
    border: "1px solid #e0e0e0",
    overflow: "hidden",
    fontWeight: "500",
    minWidth: "100%",
    textAlign: "left",
  },
  options: () => ({
    exportAllData: true,
    exportMenu: [
      {
        label: "Export All Data In CSV",
        exportFunc: (cols, data) => ExportCsv(cols, data),
      },
      {
        label: "Export All Data In PDF",
        exportFunc: (cols, data) => ExportPdf(cols, data),
      },
    ],
    selection: true,
    actionsColumnIndex: -1,
    pageSize: 10,
    addRowPosition: "first",
    detailPanelColumnAlignment: "right",
    headerStyle: {
      backgroundColor: "#00000000",
      color: "#000000",
      fontWeight: "700",
      fontSize: "1rem",
      fontFamily: "Roboto, sans-serif",
      // padding: "1rem",
      margin: "8px",
    },
  }),
};
